import {PROMOTED_SPONSORSHIP} from "../promoted-sponsorship-module.consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {PromoAnalyticsShowEvent} from "../models/promo.analytics-show-event";
import {APP} from "../../../core/app/consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";

export class PromotedSponsorshipModuleShowEventHandler extends AnalyticsEventHandler {
  type = PROMOTED_SPONSORSHIP.ACTION_TYPES.sponsorshipShow;
  static injectables = [...AnalyticsEventHandler.injectables];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PromoAnalyticsShowEvent;
  }

  async action() {
    const params = {
      source: APP.ANALYTICS.SOURCES.mainHeader,
      promoName: this.state.sponsorship?.name
    };

    const showEvent = new this.eventType(params);

    this.analyticsService.createEvent(showEvent);
  }
}
